/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Save_ChangesInputs */

const es_common_save_changes = /** @type {(inputs: Common_Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const en_common_save_changes = /** @type {(inputs: Common_Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Common_Save_ChangesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const common_save_changes = /** @type {((inputs?: Common_Save_ChangesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Save_ChangesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_save_changes(inputs)
	return en_common_save_changes(inputs)
});
export { common_save_changes as "common.save_changes" }